import moment from 'moment-timezone';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const SDAY_FORMAT = 'DD MMM';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const DATETIME_WITHOUT_TIMEZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const SECONDS_IN_A_DAY = 24 * 60 * 60;

export enum TimeFormat {
  Hour24 = '24',
  Hour12 = '12',
}

export enum WeekStartDay {
  Monday = 'monday',
  Sunday = 'sunday',
}

export enum WeekDayNumber {
  Sunday = 0,
  Monday = 1,
}

export enum RoundingType {
  Up = 'up',
  Down = 'down',
}

let defaultTimezone: string = moment.tz.guess();

export function setDefaultTimezone(timezone: string): void {
  defaultTimezone = timezone || defaultTimezone;
  moment.tz.setDefault(defaultTimezone);
}

export function getDefaultTimezone(): string {
  return defaultTimezone;
}

export function getSecondsInDays(seconds: number, rounding?: RoundingType) {
  if (rounding) {
    return rounding === RoundingType.Up
      ? Math.ceil(seconds / SECONDS_IN_A_DAY)
      : Math.floor(seconds / SECONDS_IN_A_DAY);
  }
  return Math.round(seconds / SECONDS_IN_A_DAY);
}

export function getDaysInSeconds(days: number) {
  return days * SECONDS_IN_A_DAY;
}

export function resolveWeekType(): Extract<moment.unitOfTime.StartOf, 'isoWeek' | 'week'> {
  return moment.localeData().firstDayOfWeek() === WeekDayNumber.Monday ? 'isoWeek' : 'week';
}

export function getFormattedTimezone(timezone: string): string {
  return `(GMT${moment.tz(timezone).format('Z')}) ${timezone}`;
}

export function getFormattedDateBasedTimezone(date: string, timezone: string): string {
  return `(GMT${moment.utc(date).tz(timezone).format('Z')}) ${timezone}`;
}

export const diffDates = (
  date: string | moment.Moment,
  unitOfTime: 'days' | 'months' = 'days',
): number =>
  Math.round(
    (moment.isMoment(date) ? date : moment(date).endOf(unitOfTime)).diff(
      moment(),
      unitOfTime,
      unitOfTime === 'months',
    ),
  );
